let bedwidth = localStorage.getItem("bed-size") || "3FT";
let prevC = JSON.parse(localStorage.getItem("3dc") || "{}");
let currentWidth = "4ft";
let currentOpenState = prevC["open-state"] || "close";
let currentHeadboardShape = prevC["bedFrameShape"] || "plainJane";
let currentFootboardShape = prevC["bedFrameShape-fb"] || "plainJane";
let currentHeadboardUpholstery = prevC["upholstery"] || "plane";
let currentFootboardUpholstery = prevC["upholstery-fb"] || "plane";
let currentHeadboardWings = prevC["feature-opt-wings"] || "none";
let currentHeadboardWingBeads = null;
let currentHeadboardBumper = prevC["feature-opt-bumper"] || "none";
let currentHeadboardHeight = prevC["headboardHeight"] || "50in";
let currentFootboardHeight = prevC["footboardHeight"] || "10in";
let currentMaterial = prevC["material-opt"]?.split("-")[0] || "plush";
let currentColour = prevC["material-opt"]?.split("-")[1] || "steelGrey";
let currentMatress = prevC["mattress-opt"] || null;
let currentOttoman = prevC["storage-opt"] || "slats";
let currentOttomanBox = prevC["ottomanBox-opt"] || "none";
let currMatressOpenState = null;
let matressOpenState = null;
let currentBaseboard = prevC["underBedLowerFloor-opt"] || null;
let currentLegs = prevC["legs-opt"] || null;
let legType = localStorage.getItem("legt");
// let currentFeet = null;
// let currentFeetFinish = null;
let posOverride = [0, 0, 0];

if (bedwidth) {
  const deskbed = document.getElementById("iframe");
  switch (bedwidth) {
    case "3FT": {
      deskbed.src = "https://development.modeconfigurator.com/SVI/single";
      currentWidth = "3ft";
      break;
    }
    case "4FT": {
      deskbed.src = "https://development.modeconfigurator.com/SVI/small-double";
      currentWidth = "4ft";
      break;
    }
    case "4FT6": {
      deskbed.src = "https://development.modeconfigurator.com/SVI/double";
      currentWidth = "4.6ft";
      break;
    }
    case "5FT": {
      deskbed.src = "https://development.modeconfigurator.com/SVI/king";
      currentWidth = "5ft";
      break;
    }
    case "6FT": {
      deskbed.src = "https://development.modeconfigurator.com/SVI/superking";
      currentWidth = "6ft";
      break;
    }
    default:
      deskbed.src = "https://development.modeconfigurator.com/SVI/single";
      currentWidth = "3ft";
      break;
  }
}

//todo defines default values

let currentHeadboardJSONData = `headboard-${currentWidth}-${currentHeadboardShape}-${currentHeadboardHeight}-${currentHeadboardUpholstery}${
  currentHeadboardBumper !== "none" ? "-bumper" : ""
}`;
let currentHeadboardBackJSONData = `headboard-${currentWidth}-${currentHeadboardShape}-${currentHeadboardHeight}-${currentHeadboardUpholstery}${
  currentHeadboardBumper !== "none" ? "-bumper" : ""
}-${"back"}`;
let currentFootboardJSONData = `footboard-${currentWidth}-${currentFootboardShape}-${currentFootboardHeight}-${currentFootboardUpholstery}`;
let currentSidesJSONData = `siderails-${currentWidth}-${"10in"}`;
let currentotmJSONData = `ottobox-${currentOttomanBox}-${currentOpenState}`;
let currentbaseJSONData = `baseboard-${currentWidth}-${
  parseInt(currentFootboardHeight) > 10 ? "14in" : "10in"
}-${currentOpenState}`;
let currentMatJSONData = `matress-${currentWidth}-${currentMatress}-${
  parseInt(currentFootboardHeight) > 10 ? "14in" : "10in"
}-${currentOpenState === "close" ? "plane" : "45"}`;
let currentlegJSONData = `leg-${currentWidth}-${
  currentLegs?.includes("chrome") ? currentLegs : legType
}`;
let currentwingJSONData = `headboardWing-${currentWidth}-${currentHeadboardShape}-${currentHeadboardHeight}-${currentHeadboardWings}`;
let currentOttomanJSONData = `ottoman-${currentWidth}-${currentOttoman}-${
  currentFootboardHeight === "10in" ? "10in" : "14in"
}-${currentOpenState}`;
let currentOttoBoxJSONData =
  currentOttomanBox !== "none"
    ? `ottobox-${currentOttomanBox}-${currentHeadboardUpholstery}-close`
    : null;
let currentOttoBoxStaticJSONData =
  currentOttomanBox !== "none"
    ? `ottobox-${currentOttomanBox}-${currentHeadboardUpholstery}-close-static`
    : null;

let jsonData = {
  currentOttoman: null,
  currentOttomanBox: null,
  currentHeadboard: null,
  currentHeadboardBack: null,
  currentFootboard: null,
  currentSides: null,
  currentWings: null,
  currentBeads: null,
  currentFeet: null,
  currentMatress: null,
  currentBaseboard: null,
  currentOttomanBoxStatic: null,
};

//todo converting the json value using current selction
for (let key in jsonData) {
  let data = {};
  switch (key) {
    case "currentOttoman":
      data[currentOttomanJSONData] = { materialOverride: `` };
      break;
    case "currentOttomanBox":
      if (currentOttoBoxJSONData) {
        data[currentOttoBoxJSONData] = {
          materialOverride: `${currentMaterial}-${currentColour}`,
          positionOverride: posOverride,
        };
      }
      break;
    case "currentOttomanBoxStatic":
      if (currentOttoBoxStaticJSONData)
        data[currentOttoBoxStaticJSONData] = {
          materialOverride: ``,
          positionOverride: posOverride,
        };
      break;
    case "currentHeadboard":
      data[currentHeadboardJSONData] = {
        materialOverride: `${currentMaterial}-${currentColour}`,
        positionOverride: [0, 0, 0],
      };
      break;
    case "currentHeadboardBack":
      data[currentHeadboardBackJSONData] = {
        materialOverride: `backboard`,
        positionOverride: [0, 0, 0],
      };
      break;
    case "currentFootboard":
      data[currentFootboardJSONData] = {
        materialOverride: `${currentMaterial}-${currentColour}`,
      };
      break;
    case "currentSides":
      data[currentSidesJSONData] = {
        materialOverride: `${currentMaterial}-${currentColour}`,
      };
      break;
    case "currentMatress":
      if (currentMatress !== "none" && currentMatress) {
        data[currentMatJSONData] = {
          materialOverride: "",
        };
      }
      break;
    case "currentBaseboard":
      if (currentBaseboard !== "none" && currentBaseboard) {
        data[currentbaseJSONData] = {
          materialOverride: "",
        };
      }
      break;
    case "currentWings":
      if (currentHeadboardWings !== "none" && currentHeadboardWings) {
        data[currentwingJSONData] = {
          materialOverride: `${currentMaterial}-${currentColour}`,
          positionOverride: [0, 0, 0],
        };
      }
      break;
    case "currentFeet":
      if (currentLegs) {
        if (currentLegs?.includes("chrome")) {
          switch (currentLegs) {
            case "chromeGlidesLeg":
              posOverride = [0, -0.013, 0];
              break;
            case "chromeLCornerLeg":
              posOverride = [0, -0.044, 0];
              break;
            case "chromePipeLeg":
              posOverride = [0, -0.115, 0];
              break;
            case "chromeTubeLeg":
              posOverride = [0, -0.038, 0];
              break;
          }
          const updatePositionOverride = (object) => {
            if (object) {
              Object.values(object).forEach((option) => {
                option.positionOverride = posOverride;
              });
            }
          };

          updatePositionOverride(jsonData["currentHeadboard"]);
          updatePositionOverride(jsonData["currentHeadboardBack"]);
          updatePositionOverride(jsonData["currentWings"]);
          updatePositionOverride(jsonData["currentOttomanBox"]);
          data[currentlegJSONData] = {
            materialOverride: "",
          };
        } else if (currentLegs === "none") {
        } else {
          data[currentlegJSONData] = {
            materialOverride: currentLegs,
          };
        }
      }
      break;
  }
  if (Object.keys(data).length === 0) data = null;
  jsonData[key] = data;
}

//todo function to update the json value according to user selction
function updateJsonValue(dataObject, key, oldValue, newValue) {
  if (dataObject[key]) {
    let data = JSON.stringify(dataObject[key]);
    data = data.replace(oldValue, newValue);
    dataObject[key] = JSON.parse(data);
  }
}
let prev = JSON.parse(localStorage.getItem("jsondata"));

//todo function to send the api request to configurator
function SendData(element) {
  let value = element.value;

  switch (element.title) {
    case "open-state": {
      let currMatressOpenState = currentOpenState === "close" ? "plane" : "45";
      let matressOpenState = value === "close" ? "plane" : "45";
      updateJsonValue(
        jsonData,
        "currentMatress",
        currMatressOpenState,
        matressOpenState
      );
      updateJsonValue(jsonData, "currentOttoman", currentOpenState, value);
      updateJsonValue(jsonData, "currentOttomanBox", currentOpenState, value);
      updateJsonValue(
        jsonData,
        "currentOttomanBoxStatic",
        currentOpenState,
        value
      );
      updateJsonValue(jsonData, "currentBaseboard", currentOpenState, value);
      currentOpenState = value;
      break;
    }
    case "bedFrameShape": {
      updateJsonValue(
        jsonData,
        "currentHeadboard",
        currentHeadboardShape,
        value
      );
      updateJsonValue(
        jsonData,
        "currentHeadboardBack",
        currentHeadboardShape,
        value
      );
      updateJsonValue(jsonData, "currentWings", currentHeadboardShape, value);
      updateJsonValue(jsonData, "currentBeads", currentHeadboardShape, value);
      currentHeadboardShape = value;
      break;
    }
    case "bedFrameShape-fb": {
      updateJsonValue(
        jsonData,
        "currentFootboard",
        currentFootboardShape,
        value
      );
      currentFootboardShape = value;
      break;
    }
    case "upholstery": {
      updateJsonValue(
        jsonData,
        "currentHeadboard",
        currentHeadboardUpholstery,
        value
      );
      updateJsonValue(
        jsonData,
        "currentHeadboardBack",
        currentHeadboardUpholstery,
        value
      );
      if (currentOttomanBox !== "none") {
        updateJsonValue(
          jsonData,
          "currentOttomanBox",
          currentHeadboardUpholstery,
          value
        );
        updateJsonValue(
          jsonData,
          "currentOttomanBoxStatic",
          currentHeadboardUpholstery,
          value
        );
      }
      currentHeadboardUpholstery = value;
      break;
    }
    case "upholstery-fb": {
      updateJsonValue(
        jsonData,
        "currentFootboard",
        currentFootboardUpholstery,
        value
      );

      currentFootboardUpholstery = value;
      break;
    }
    case "feature-opt-wings": {
      if (currentHeadboardWings !== "none") {
        if (value === "none") {
          jsonData["currentWings"] = null;
        } else {
          updateJsonValue(
            jsonData,
            "currentWings",
            currentHeadboardWings,
            value
          );
        }
      } else {
        let data = JSON.stringify(jsonData["currentHeadboard"]);
        data = data.replace("headboard", "headboardWing");
        let dataArr = data.split("-");
        dataArr.splice(-2, 0, value);
        data = dataArr.join("-");
        data = data.replace("-" + currentHeadboardUpholstery, "");

        if (currentHeadboardBumper === "bumper") {
          data = data.replace("-bumper", "");
        }
        jsonData["currentWings"] = JSON.parse(data);
      }
      currentHeadboardWings = value;
      break;
    }
    case "feature-opt-bumper": {
      if (value === "none") {
        updateJsonValue(jsonData, "currentHeadboard", '-bumper"', '"');
        updateJsonValue(jsonData, "currentHeadboardBack", "-bumper", "");
      } else {
        if (value == currentHeadboardBumper) {
          return;
        }
        // Handle the case where a specific bumper border value is set
        let data = JSON.stringify(jsonData["currentHeadboard"]);
        let dataArr = data.split("-");
        dataArr[4] = dataArr[4].replace('"', `-${value}"`);
        data = dataArr.join("-");
        jsonData["currentHeadboard"] = JSON.parse(data);

        data = JSON.stringify(jsonData["currentHeadboardBack"]);
        dataArr = data.split("-");
        dataArr.splice(5, 0, value);
        data = dataArr.join("-");
        jsonData["currentHeadboardBack"] = JSON.parse(data);
      }
      currentHeadboardBumper = value;
      break;
    }
    case "material-opt": {
      if (value) {
        for (let key in jsonData) {
          if (jsonData[key] && typeof jsonData[key] === "object") {
            for (let keys in jsonData[key]) {
              if (
                key !== "currentFeet" &&
                key !== "currentHeadboardBack" &&
                jsonData[key][keys]["materialOverride"]
              ) {
                jsonData[key][keys]["materialOverride"] = value;
                currentMaterial = value.split("-")[0];
                currentColour = value.split("-")[1];
              }
            }
          }
        }
      }
      break;
    }
    case "mattress-opt": {
      if (currentMatress !== "none") {
        if (value === "none") {
          jsonData["currentMatress"] = null;
        } else {
          let data = {
            [`matress-${currentWidth}-${value}-${
              parseInt(currentFootboardHeight) > 10 ? "14in" : "10in"
            }-${currentOpenState === "close" ? "plane" : "45"}`]: {
              materialOverride: "",
            },
          };
          jsonData["currentMatress"] = data;
        }
      } else {
        let data = {
          [`matress-${currentWidth}-${value}-${
            parseInt(currentFootboardHeight) > 10 ? "14in" : "10in"
          }-${currentOpenState === "close" ? "plane" : "45"}`]: {
            materialOverride: "",
          },
        };
        jsonData["currentMatress"] = data;
      }
      currentMatress = value;
      break;
    }
    case "ottomanBox-opt": {
      if (currentOttomanBox !== "none") {
        if (value === "none") {
          jsonData["currentOttomanBox"] = null;
          jsonData["currentOttomanBoxStatic"] = null;
        } else {
          updateJsonValue(
            jsonData,
            "currentOttomanBox",
            currentOttomanBox,
            value
          );
          updateJsonValue(
            jsonData,
            "currentOttomanBoxStatic",
            currentOttomanBox,
            value
          );
        }
      } else {
        let data = `{"ottobox-${value}-${currentHeadboardUpholstery}-${currentOpenState}":{"materialOverride":"${currentMaterial}-${currentColour}","positionOverride":[${posOverride}]}}`;
        jsonData["currentOttomanBox"] = JSON.parse(data);
        data = `{"ottobox-${value}-${currentHeadboardUpholstery}-${currentOpenState}-static":{"materialOverride":"","positionOverride":[${posOverride}]}}`;
        jsonData["currentOttomanBoxStatic"] = JSON.parse(data);
      }
      currentOttomanBox = value;
      break;
    }
    case "storage-opt": {
      updateJsonValue(jsonData, "currentOttoman", currentOttoman, value);
      currentOttoman = value;
      break;
    }
    case "underBedLowerFloor-opt": {
      if (value === "none") {
        jsonData["currentBaseboard"] = null;
      } else {
        let data = `{"baseboard-${currentWidth}-${
          parseInt(currentFootboardHeight) > 10 ? "14in" : "10in"
        }-${currentOpenState}":{"materialOverride":""}}`;
        jsonData["currentBaseboard"] = JSON.parse(data);
      }
      currentBaseboard = value;
      break;
    }
    case "legs-opt": {
      let matOverride = '"materialOverride": ""';
      let sc = element.sc;
      localStorage.setItem("legt", sc);
      let posOverride;
      matOverride = matOverride.replace(/""/, `"${value}"`);
      if (sc === "nickleCupDarkNaturalLeg" || sc === "woodenBunLeg") {
        let data = `{"leg-${currentWidth}-${sc}":{${matOverride}}}`;
        jsonData["currentFeet"] = JSON.parse(data);
        posOverride = [0, 0, 0];
      } else if (sc === "metal") {
        let data = `{"leg-${currentWidth}-${value}":{"materialOverride":""}}`;
        jsonData["currentFeet"] = JSON.parse(data);
        switch (value) {
          case "chromeGlidesLeg":
            posOverride = [0, -0.013, 0];
            break;
          case "chromeLCornerLeg":
            posOverride = [0, -0.044, 0];
            break;
          case "chromePipeLeg":
            posOverride = [0, -0.115, 0];
            break;
          case "chromeTubeLeg":
            posOverride = [0, -0.038, 0];
            break;
        }
      } else {
        posOverride = [0, 0, 0];
        jsonData["currentFeet"] = null;
      }
      const updatePositionOverride = (object) => {
        if (object) {
          Object.values(object).forEach((option) => {
            option.positionOverride = posOverride;
          });
        }
      };

      updatePositionOverride(jsonData["currentHeadboard"]);
      updatePositionOverride(jsonData["currentHeadboardBack"]);
      updatePositionOverride(jsonData["currentWings"]);
      updatePositionOverride(jsonData["currentOttomanBox"]);
      break;
    }
    case "headboardHeight": {
      if (value == "customHeight") {
        return;
      }
      updateJsonValue(
        jsonData,
        "currentHeadboard",
        currentHeadboardHeight,
        value
      );
      updateJsonValue(
        jsonData,
        "currentHeadboardBack",
        currentHeadboardHeight,
        value
      );

      if (jsonData["currentWings"]) {
        updateJsonValue(
          jsonData,
          "currentWings",
          currentHeadboardHeight,
          value
        );
      }

      if (jsonData["currentBeads"]) {
        updateJsonValue(
          jsonData,
          "currentBeads",
          currentHeadboardHeight,
          value
        );
      }

      currentHeadboardHeight = value;
      break;
    }
    case "footboardHeight": {
      if (value == "customHeight") {
        return;
      }
      updateJsonValue(
        jsonData,
        "currentFootboard",
        currentFootboardHeight,
        value
      );
      if (jsonData["currentMatress"]) {
        if (parseInt(value) > 10) {
          updateJsonValue(jsonData, "currentMatress", "10in", "14in");
          currentFootboardHeight = "14in";
        } else {
          updateJsonValue(jsonData, "currentMatress", "14in", "10in");
          currentFootboardHeight = "10in";
        }
      }
      currentFootboardHeight = value;
      break;
    }
  }
  {
    const outputObject = JSON.parse(localStorage.getItem("3dc")) || {};
    const userSelection = element;
    if (userSelection.title in outputObject) {
      outputObject[userSelection.title] = userSelection.value;
    } else {
      outputObject[userSelection.title] = userSelection.value;
    }
    localStorage.setItem("3dc", JSON.stringify(outputObject));
  }
  {
    console.log(jsonData);
    document
      .getElementById("iframe")
      .contentWindow.postMessage(JSON.stringify(jsonData), "*");
  }
}

window.addEventListener("message", (event) => {
  try {
    let data = JSON.parse(event.data);
    if (data.title === "open-state" && data.value) {
      SendData(data);
    } else {
      window.location.reload();
    }
  } catch (error) {
    return;
  }
});

function stringToCamelCase(inputString) {
  const words = inputString.split(" ");
  const camelCaseWords = words.map((word, index) => {
    if (index === 0) {
      return word.toLowerCase();
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
  });
  const camelCaseString = camelCaseWords.join("");
  return camelCaseString;
}

document.addEventListener("click", function (event) {
  const child = event.target.parentElement;
  let parent = event.target;
  if (
    parent.classList.contains("dropdown_item") ||
    child.classList.contains("dropdown_item")
  ) {
    let isHb, isFb, optName, secOpt, val;
    if (child.classList.contains("dropdown_item")) {
      val = stringToCamelCase(child?.children[1]?.innerHTML);
      optName = child?.classList[1];
      secOpt = child?.classList[2];
      isHb = child.classList.contains("headboard");
      isFb = child.classList.contains("footboard");
    }
    if (parent.classList.contains("dropdown_item")) {
      val = stringToCamelCase(parent?.children[1]?.innerHTML);
      optName = parent?.classList[1];
      secOpt = parent?.classList[2];
      isHb = parent.classList.contains("headboard");
      isFb = parent.classList.contains("footboard");
    }

    let data;
    const isSel =
      child.classList.contains("selected") ||
      parent.classList.contains("selected");
    switch (optName) {
      case "bedFrameShape": {
        data = { title: optName, value: val };
        if (isHb) {
          SendData(data);
        }
        if (isFb) {
          data = { title: `${optName}-fb`, value: val };
          SendData(data);
        }
        break;
      }
      case "upholstery": {
        let value = convertval(val);
        data = { title: optName, value };
        if (isHb) {
          SendData(data);
        }
        if (isFb) {
          data = { title: `${optName}-fb`, value };
          SendData(data);
        }
        break;
      }
      case "feature-opt": {
        let value = convertval(val);
        data = { title: `${optName}-${secOpt}`, value };
        SendData(data);
        break;
      }
      case "material-opt": {
        let matval = document.getElementById("material").innerHTML;
        let material = convertmat(stringToCamelCase(matval.split("-")[0]));
        let col = convertCol(stringToCamelCase(matval.split("-")[1]), material);
        data = { title: optName, value: `${material}-${col}` };
        SendData(data);
        break;
      }
      case "mattress-opt": {
        let matressval = document.getElementById("mattress").innerHTML;
        if (matressval.includes("-")) {
          matressval = matressval.split("-")[0];
        }
        let value = convertval(stringToCamelCase(matressval));
        data = { title: optName, value };
        SendData(data);
        break;
      }
      case "ottomanBox-opt": {
        let value = convertval(val);
        data = { title: optName, value };
        SendData(data);
        break;
      }
      case "storage-opt": {
        let value = convertval(val);
        data = { title: optName, value };
        SendData(data);
        break;
      }
      case "underBedLowerFloor-opt": {
        let value = convertval(val);
        data = { title: optName, value };
        SendData(data);
        break;
      }
      case "legs-opt": {
        let value = convertval(val);
        let sc = "none";
        if (val.includes("Wooden")) {
          sc = "woodenBunLeg";
        }
        if (val.includes("Cup")) {
          sc = "nickleCupDarkNaturalLeg";
        }
        if (val.includes("chrome")) {
          sc = "metal";
        }
        data = { title: optName, value, sc };
        SendData(data);
        break;
      }
      case "headboardHeight": {
        let value = convertval(val);
        data = { title: optName, value };
        SendData(data);
        break;
      }
      case "footboardHeight": {
        let value = convertval(val);
        data = { title: optName, value };
        SendData(data);
        break;
      }
      default:
        break;
    }
  }
});

let convertCol = (value, material) => {
  let returnValue;
  switch (value) {
    case "blackNoir":
      if (material == "suede" || material == "crushedVelvet") {
        returnValue = "blackNoir";
      } else if (material == "plush") {
        returnValue = "black";
      } else {
        returnValue = value;
      }

      break;
    case "babyPink":
      if (material == "mystic") {
        returnValue = "pink";
      } else if (material == "crushedVelvet") {
        returnValue = "babyPink";
      } else if (material == "plush") {
        returnValue = "babyPink";
      } else {
        returnValue = "black";
      }

      break;
    case "mallard":
      returnValue = "mallardBlue";
      break;
    case "midnightBlue":
      returnValue = "mallardBlue";
      break;
    case "denim":
      returnValue = "denimBlue";
      break;
    case "roseRed":
      returnValue = "red";
      break;
    case "cream":
      if (material == "chenille") {
        returnValue = "mink";
      }
      returnValue = value;
      break;
    default:
      returnValue = value;
      break;
  }
  return returnValue;
};
let convertmat = (material) => {
  let returnValue;
  switch (material) {
    case "crushed":
      returnValue = "crushedVelvet";
      break;
    case "coniston":
      returnValue = "conistonHouse";
      break;
    default:
      returnValue = material;
      break;
  }
  return returnValue;
};
// plush - babyPink midnightblue
// mystic - babyPink midnightblue
// naples - black
// wool - chestnutBRown

let convertval = (value) => {
  let returnval;
  switch (value) {
    case "plainJane": {
      returnval = "plane";
      break;
    }
    case "lines-horizontal-large": {
      returnval = "hLargeLine";
      break;
    }
    case "lines-horizontal-small": {
      returnval = "hSmallLine";
      break;
    }
    case "lines-vertical-large": {
      returnval = "vLargeLine";
      break;
    }
    case "lines-vertical-small": {
      returnval = "vSmallLine";
      break;
    }
    case "cube-design-large": {
      returnval = "largeCube";
      break;
    }
    case "cube-design-small": {
      returnval = "smallCube";
      break;
    }
    case "sunrise": {
      returnval = "sR";
      break;
    }
    case "victoria": {
      returnval = "victoria";
      break;
    }
    case "chesterfield-large": {
      returnval = "chesterfieldSmall";
      break;
    }
    case "chesterfield-small": {
      returnval = "chesterfieldLarge";
      break;
    }
    case "majestic-multi-panel": {
      returnval = "mayfair";
      break;
    }
    case "straightwing–plain": {
      returnval = "straight";
      break;
    }
    case "curvedwing–plain": {
      returnval = "curve";
      break;
    }
    case "none": {
      returnval = "none";
      break;
    }
    case "bumperBorder–plain": {
      returnval = "bumper";
      break;
    }
    case "notRequired": {
      returnval = "none";
      break;
    }
    case "sameWidthAsBed": {
      returnval = currentWidth;
      break;
    }
    case "luxuryPocket": {
      returnval = "luxuary";
      break;
    }
    case "premiumPocket": {
      returnval = "premium";
      break;
    }
    case "memoryPocket": {
      returnval = "memory";
      break;
    }
    case "orthopaedicMemory": {
      returnval = "orthopaedic";
      break;
    }
    case "notRequired": {
      returnval = "none";
      break;
    }
    case "solidFlatWoodenSlats": {
      returnval = "slats";
      break;
    }
    case "premiumReinforcedGasliftOttoman": {
      returnval = "premium";
      break;
    }
    case "solidPlatformBaseBoard": {
      returnval = "entry";
      break;
    }
    case 'standardHeight48"': {
      returnval = "50in";
      break;
    }
    case "54”Headboard": {
      returnval = "54in";
      break;
    }
    case 'moyenFootboard18"': {
      returnval = "18in";
      break;
    }
    case 'hauteFootboard24"': {
      returnval = "24in";
      break;
    }
    case 'petiteFootboard12"': {
      returnval = "10in";
      break;
    }
    case "noLegs": {
      returnval = "withoutLeg";
      break;
    }
    case "mahoganyWoodenBun": {
      returnval = "mahogany-wood";
      break;
    }
    case "naturalWoodenBun": {
      returnval = "natural-wood";
      break;
    }
    case "sandedWoodenBun": {
      returnval = "sanded-wood";
      break;
    }
    case "darkWoodenBun": {
      returnval = "dark-wood";
      break;
    }
    case "chromeGlides": {
      returnval = "chromeGlidesLeg";
      break;
    }
    case "darkNatural–silverCup": {
      returnval = "dark-natural-wood";
      break;
    }
    case "wengeBlack–silverCup": {
      returnval = "wenge-black-wood";
      break;
    }
    default:
      returnval = value;
      break;
  }
  return returnval;
};
